//
//
//
//

import $ from 'jquery'
import 'bootstrap-daterangepicker/daterangepicker.js'
import 'bootstrap-daterangepicker/daterangepicker.css'
import moment from 'moment'

const events = {'show-daterangepicker': 'show.daterangepicker', 'hide-daterangepicker': 'hide.daterangepicker', 'showCalendar-daterangepicker': 'showCalendar.daterangepicker', 'hideCalendar-daterangepicker': 'hideCalendar.daterangepicker', 'apply-daterangepicker': 'apply.daterangepicker', 'cancel-daterangepicker': 'cancel.daterangepicker'}

export default {
  name: 'date-range-picker',
  components: {
  },
  props: {
    value: {
      default: null,
      required: true,
      validator (value) {
        return value instanceof Object || value instanceof Date || typeof value === 'string' || value instanceof String || value instanceof moment
      }
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      drp: null,
      // jQuery DOM
      elem: null
    }
  },
  created () {
  },
  mounted () {
    // Return early if date-picker is already loaded
    /* istanbul ignore if */
    if (this.drp) return
    this.elem = $(this.$el)
    // Init date-range-picker
    let $this = this
    this.elem.daterangepicker(this.options, this.onChange)
    // Store data control
    this.drp = this.elem.data('daterangepicker')
    // Register remaining events
    this.registerEvents()

    this.onChange(this.drp.startDate, this.drp.endDate)
  },
  /**
   * Free up memory
   */
  beforeDestroy () {
    /* istanbul ignore else */
    if (this.drp) {
      this.drp = null;
      this.elem = null;
    }
  },
  watch: {
    /**
     * Listen to change from outside of component and update DOM
     *
     * @param newValue
     */
    value (newValue) {
      if (this.drp) {
        if (this.options.singleDatePicker === true) {
          if (newValue.startDate) {
            this.drp.setStartDate(newValue.startDate || null)
          } else {
            this.elem.val('')
          }
        } else {
          if (newValue.startDate && newValue.endDate) {
            this.drp.setStartDate(newValue.startDate || null)
            this.drp.setEndDate(newValue.endDate || null)
          } else {
            this.elem.val('')
          }
        }
      }
    },

    /**
     * Watch for any change in options and set them
     *
     * @param newOptions Object
     */
    options: {
      deep: true,
      handler (newOptions) {
        this.elem.daterangepicker(newOptions, this.onChange);
        this.drp = this.elem.data('daterangepicker');
      }
    }
  },
  computed: {
  },
  methods: {
    /**
     * Update v-model upon change triggered by date-picker itself
     *
     * @param event
     */
    onChange (start, end, label) {
      this.value.startDate = start
      this.value.startDateText = start.format(this.options.locale.format)
      if (this.options.singleDatePicker !== true) {
        this.value.endDate = end
        this.value.endDateText = end.format(this.options.locale.format)
      }
    },
    onCancel (e, picker) {
      this.elem.val('')
      this.value.startDate = ''
      this.value.startDateText = ''
      if (this.options.singleDatePicker !== true) {
        this.value.endDate = ''
        this.value.endDateText = ''
      }
    },
    /**
     * Emit all available events
     */
    registerEvents () {
      let $this = this
      for (let key in events) {
        let event = events[key]
        $this.elem.on(event, (...args) => {
          if (key === 'cancel-daterangepicker') {
            $this.onCancel(args)
          } else if (key === 'apply-daterangepicker') {
            $this.onChange(this.drp.startDate, this.drp.endDate)
          }
          $this.$emit(key, ...args);
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/DateRangePicker.vue